export default "__VITE_ASSET__hIFByocL__"